module.exports = __webpack_public_path__ + "img/125.12e35748.png";